module.exports = __webpack_public_path__ + "static/media/icon-products.0a8c6636.svg";